import React, { useEffect } from 'react';

import { usePokCore } from '../../../common/hooks/usePokCore';
import momencik from '../../../common/momencik';

import { Option, Selector } from './Selector';

export interface ProjectSelectorProps {
  onChange?: (option: Option | undefined) => void;
  companyId?: string;
  withChangeCompany?: boolean;
  value?: string;
  readOnly?: boolean;
  clearable?: boolean;
}

export default (props: ProjectSelectorProps) => {
  const pok = usePokCore();
  const [value, setValue] = React.useState<string | undefined>(props.value);

  useEffect(() => {
    setValue(props.value);
  }, [props.value, props.companyId, props.withChangeCompany]);

  const provider = async (text: string) => {
    const values = await pok.projects.getAllByFilter(
      text,
      props.companyId || undefined,
    );
    if (props.value) {
      const fullValue = await pok.projects.getById(props.value);
      if (
        fullValue &&
        (!props.withChangeCompany || fullValue.company?.id === props.companyId)
      ) {
        values.push(fullValue);
      } else {
        setValue(undefined);
        props.onChange?.(undefined);
      }
    }
    return Array.from(values, p => ({
      value: p.id,
      label: `${p.number} - ${p.name}   (${momencik(
        p.startDate,
        'L',
      )} - ${momencik(p.endDate, 'L')})`,
    }));
  };

  return (
    <Selector
      key={
        'projects-' +
        JSON.stringify(provider) +
        JSON.stringify(value) +
        JSON.stringify(props.companyId)
      }
      creatable={false}
      provider={provider}
      onChange={option => props.onChange && props.onChange(option as Option)}
      value={value}
      readOnly={props.readOnly || (props.withChangeCompany && !props.companyId)}
      clearable={props.clearable}
    />
  );
};
